<section *ngIf="isShw()">
    <div class="page-header-area sec-overlay sec-overlay-black"
        style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;">
        <div class="container pt--0 pb--0">
            <div class="row">
                <div class="col-12">
                    <div class="page-header-content">
                        <h2 class="title">Jobs</h2>
                        <nav class="breadcrumb-area">
                            <ul class="breadcrumb justify-content-center">
                                <li><a href="index.html">Home</a></li>
                                <li class="breadcrumb-sep"> / </li>
                                <li>Jobs</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="recent-job-area bg-color-gray" *ngIf="!isShowhide">
    <div class="vh-section-outer d-table w-100 bg-secondary text-white">
        <div class="section-inner d-table-cell align-middle">
            <div class="">
                <div class="tabSection bg-white text-dark p-4 rounded">
                    <ul class="nav nav-pills justify-content-center flex-wrap mb-3" id="productTabs" role="tablist"
                        *ngIf="!isShw()">
                        <li class="nav-item category-link" role="presentation">
                            <button class="nav-link active" id="product1-tab" data-bs-toggle="pill"
                                data-bs-target="#product1" type="button" role="tab">Popular Jobs</button>
                        </li>
                        <li class="nav-item category-link" role="presentation">
                            <button class="nav-link" id="product2-tab" data-bs-toggle="pill" data-bs-target="#product2"
                                type="button" role="tab">Start-ups</button>
                        </li>
                        <li class="nav-item category-link" role="presentation">
                            <button class="nav-link" id="product3-tab" data-bs-toggle="pill" data-bs-target="#product3"
                                type="button" role="tab">Internships</button>
                        </li>
                    </ul>
                    <div class="tab-content pt-4" id="productTabsContent">
                        <div class="tab-pane fade show active" id="product1" role="tabpanel">
                            <section class="recent-job-area bg-color-gray">
                                <div class="container aos-init aos-animate mt-2 mb-2 pt-4 pb-4" data-aos="fade-down">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="section-title text-center mb-4">
                                                <h3 class="title">Popular Jobs</h3>
                                                <div class="desc">
                                                    <p>Browse the most popular jobs chosen by thousands. <br />
                                                        Your next big opportunity could be just a click away.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 col-lg-4" *ngFor="let item of listGrid"
                                            (click)="jobDetails(item)">
                                            <div class="recent-job-item p-3">
                                                <!-- <div class="company-info card-body">
                                                    <div class="logo">
                                                        <a>
                                                            <img src="../../../../assets/images/new-images/OUK_Logo 1.png"
                                                                width="75" height="75" alt="Image-HasTech">
                                                        </a>
                                                    </div>
                                                    <div class="content">
                                                        <h4 class="name"><a>{{item.company_name}}</a></h4>
                                                        <p class="address">{{item?.sub_counties_name}},
                                                            {{item?.counties_name}}</p>
                                                    </div>
                                                </div> -->
                                                <div class="main-content">
                                                    <h3 class="title"><a>{{item.job_title}}</a></h3>
                                                    <h5 class="work-type">{{item?.job_type}}</h5>
                                                    <span><i class="bi bi-calendar-check-fill"></i>
                                                        {{item?.experience_level}}</span> &nbsp;
                                                </div>
                                                <div class="recent-job-info">
                                                    <div class="salary">
                                                        <span> <i class="bi bi-geo-alt-fill"></i>
                                                            {{item?.counties_name}} - {{item?.sub_counties_name}}</span>
                                                        &nbsp;
                                                    </div>
                                                    <a class="btn-theme btn-sm" (click)="jobDetails(item)">Apply Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="tab-pane fade" id="product2" role="tabpanel">
                            <section>
                                <!-- <div class="container pt-3 pb-0 mb-2">
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <h3 class="fw-bold">Popular Categories </h3>
                                        </div>
                                    </div>
                                </div>
                                 -->

                                <div class="row">
                                    <div class="col-12">
                                        <div class="section-title text-center mb-4">
                                            <h3 class="title">Work with Trailblazers. Intern at Startups Changing the
                                                World</h3>
                                            <div class="desc">
                                                <p class="mb-2">Get hands-on experience at fast-growing startups across
                                                    Kenya and beyond. <br> Learn directly from founders, take on
                                                    meaningful
                                                    responsibilities, and make a real impact from day one.</p>
                                                <ul class="d-flex text-center justify-content-center mb-2">
                                                    <li class="btn btn-outline-primary">Fast-paced learning environments
                                                    </li> &nbsp;
                                                    <li class="btn btn-outline-primary">Collaborate directly with
                                                        founders and small teams</li>
                                                </ul>
                                                <ul class="d-flex text-center justify-content-center">
                                                    <li class="btn btn-outline-primary">High-growth exposure with real
                                                        outcomes
                                                    </li> &nbsp;
                                                    <li class="btn btn-outline-primary">Pathways to full-time employment
                                                    </li>
                                                </ul>
                                                <p class="text-center  d-flex justify-content-center"><a (click)="ApplyNow()"
                                                        class="btn btn-sm btn-theme w-50">
                                                        Don’t wait. Kickstart your
                                                        career with the right internship today. <i
                                                            class="bi bi-arrow-right-circle"></i></a></p>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="container py-4 popularjobs">

                                    <div class="row g-4">
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                                            (click)="LoadGrid('header')">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 1024 1024" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            Business Development</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">74 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                                            (click)="LoadGrid('header')">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 16 16" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M14.5 2H9l-.35.15-.65.64-.65-.64L7 2H1.5l-.5.5v10l.5.5h5.29l.86.85h.7l.86-.85h5.29l.5-.5v-10l-.5-.5zm-7 10.32l-.18-.17L7 12H2V3h4.79l.74.74-.03 8.58zM14 12H9l-.35.15-.14.13V3.7l.7-.7H14v9zM6 5H3v1h3V5zm0 4H3v1h3V9zM3 7h3v1H3V7zm10-2h-3v1h3V5zm-3 2h3v1h-3V7zm0 2h3v1h-3V9z"
                                                                fill-rule="evenodd" clip-rule="evenodd"></path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">Marketing &amp;
                                                            Communication</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">20 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                                            (click)="LoadGrid('header')">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 1024 1024" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            Project Management</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">35 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
                                            (click)="LoadGrid('header')">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 24 24" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            Software Engineering
                                                        </a>
                                                    </h5>
                                                    <p class="text-muted mb-0">60 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 1024 1024" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            Human Resource HR</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">74 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 16 16" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                d="M14.5 2H9l-.35.15-.65.64-.65-.64L7 2H1.5l-.5.5v10l.5.5h5.29l.86.85h.7l.86-.85h5.29l.5-.5v-10l-.5-.5zm-7 10.32l-.18-.17L7 12H2V3h4.79l.74.74-.03 8.58zM14 12H9l-.35.15-.14.13V3.7l.7-.7H14v9zM6 5H3v1h3V5zm0 4H3v1h3V9zM3 7h3v1H3V7zm10-2h-3v1h3V5zm-3 2h3v1h-3V7zm0 2h3v1h-3V9z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            It &amp; Networking
                                                        </a>
                                                    </h5>
                                                    <p class="text-muted mb-0">35 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 1024 1024" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">
                                                            Sales &amp; Marketing</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">35 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                                            <div class="card text-center h-100">
                                                <div
                                                    class="card-body d-flex flex-column align-items-center justify-content-center">
                                                    <div class="bg-success bg-opacity-10 rounded-circle p-3 mb-3">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                                            viewBox="0 0 24 24" height="2em" width="2em"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z">
                                                            </path>
                                                        </svg>
                                                    </div>
                                                    <h5 class="card-title">
                                                        <a href="/job-categories"
                                                            class="text-decoration-none text-dark">Data Science</a>
                                                    </h5>
                                                    <p class="text-muted mb-0">60 Jobs</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="tab-pane fade" id="product3" role="tabpanel">
                            <div class="container-fluid pt-1 pb-1">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="section-title text-center mb-4">
                                            <h3 class="title">Intern. Learn. Lead.</h3>
                                            <div class="desc">
                                                <p class="mb-2">Discover internships across multiple domains from
                                                    software engineering and HR to data science and marketing. <br> Gain
                                                    real-world experience, develop practical skills, and take the first
                                                    step toward your future career.</p>
                                                <ul class="d-flex text-center justify-content-center mb-2">
                                                    <li class="btn btn-outline-primary">Designed for OUK learners and
                                                        graduates</li> &nbsp;
                                                    <li class="btn btn-outline-primary">Hands-on projects with real
                                                        impact</li>
                                                </ul>
                                                <ul class="d-flex text-center justify-content-center">
                                                    <li class="btn btn-outline-primary">Verified internship completion
                                                    </li> &nbsp;
                                                    <li class="btn btn-outline-primary">Mentorship and career
                                                        development
                                                    </li>
                                                </ul>
                                                <p class="text-center  d-flex justify-content-center"><a (click)="ApplyNow()"
                                                        class="btn btn-sm btn-theme w-50">
                                                        Don’t wait. Kickstart your
                                                        career with the right internship today. <i
                                                            class="bi bi-arrow-right-circle"></i></a></p>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-lg-3 mb-2" *ngFor="let item of companyList">
                                        <div class="recent-job-item p-0  h-100 text-center justify-content-center">
                                            <div class="main-content">
                                                <h3 class="title"><a>{{item.COMPANY_NAME}}</a></h3>
                                                <div class="thumb text-center">
                                                    <!-- (click)="onCategoryChanged(category.id)" -->
                                                    <a>
                                                        <img *ngIf="item.cmp_logo" alt="Image-HasTech"
                                                            [src]="fileUrl + item.cmp_logo" height="120"
                                                            class="img-thumbnail img-fluid" width="120">
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="recent-job-info text-center justify-content-center">
                                                <a class="btn-theme btn-sm" (click)="SrchType(item)">View Details</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="product3" role="tabpanel" *ngIf="false">
                            <!-- <app-tutor-home></app-tutor-home>  this.companyList-->
                            <section [ngClass]="{'pt-1':!isShowAll}" [ngStyle]="{'padding-top':isShowAll?'7rem':null}"
                                *ngIf="jobSearchType != 'job'">
                                <div class="page-header-area sec-overlay sec-overlay-black"
                                    *ngIf="isShowCourseSche || isShowCourseSch"
                                    style="background-image: url('../../../../assets/images/new-images/Inner-Banner.png'); background-repeat: no-repeat;">
                                    <div class="container pt--0 pb--0">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="page-header-content">
                                                    <h2 class="title">Internship Details</h2>
                                                    <nav class="breadcrumb-area">
                                                        <ul class="breadcrumb justify-content-center">
                                                            <li><a href="">Home</a></li> <span>/ </span>
                                                            <li><a routerLink="/menu/internships">Internship Details</a>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="container pt-2 pb-2">
                                        <div class="row">
                                            <div class="col-sm-6 col-lg-4 col-xl-3 mb-2 "
                                                *ngFor="let category of categoryList;">
                                                <div class="team-item h-100">
                                                    <div class="thumb">
                                                        <a (click)="onCategoryChanged(category.id)">
                                                            <img *ngIf="category.cmp_logo" alt="Image-HasTech"
                                                                [src]="fileUrl + category.cmp_logo" height="120"
                                                                class="img-thumbnail img-fluid" width="120">
                                                        </a>
                                                    </div>
                                                    <div class="content">
                                                        <h6 class="name">{{category.name}}</h6>
                                                        <a class="btn-theme btn-white btn-sm"
                                                            (click)="onCategoryChanged(category.id)">View Profile</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="container pt-1 pb-1" *ngIf="isShowCourseSche || isShowCourseSch">
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <div class="bg-white">
                                                <form>
                                                    <div class="row g-3 mt-5 align-items-center">
                                                        <div class="col-6">
                                                            <label for="companySelect"
                                                                class="form-label fw-semibold mb-0">
                                                                Search Company</label>
                                                            <select id="searchname"
                                                                class="form-select form-select-sm shadow-sm rounded mt-1 mb-1"
                                                                [(ngModel)]="intrmcompany_id" name="company_id"
                                                                (change)="getAllCourseCategory('Iner')">
                                                                <option value="0" selected>Choose Company</option>
                                                                <option *ngFor="let item of companyList"
                                                                    [value]="item.COMPANY_ID">
                                                                    {{item.COMPANY_NAME }}</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-6 text-end">
                                                            <h3 class="fw-bold">
                                                                <button
                                                                    class="btn btn-sm btn-info mb-0 bg-transparent border-0"
                                                                    (click)="backToCompanies()">
                                                                    <i class="bi bi-arrow-left-circle-fill"></i>
                                                                </button>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="col-xl-12" *ngFor="let course of courseList;">
                                            <div class="card mb-2 bg-light shadow-sm">
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <img [src]="course.COURSE_IMAGE || course.IMAGE_URL"
                                                                width="130" height="130" alt="profile-sample1"
                                                                class=" img-fluid img_crs_1" />
                                                        </div>
                                                        <div>
                                                            <h6 class="title mb-0 fw-bold">{{course.COURSE_NAME}}</h6>
                                                        </div>
                                                        <div>
                                                            <i class="bi bi-play-circle-fill  me-2"></i><br />
                                                            Start date: {{course?.COURSESHD_STARTDATE |
                                                            date:'dd-MM-yyyy'}}
                                                        </div>
                                                        <div>
                                                            <i class="bi bi-cash-coin  me-3"></i><br />
                                                            Stipend: ₹ {{course?.COURSESHD_AMOUNT}} /month
                                                        </div>
                                                        <div>
                                                            <button class="btn-theme p-1"
                                                                (click)="gotoCourseDetail(course)">
                                                                <i class="bi bi-eye-fill"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="row mt-2 mb-2 container" *ngIf="isShowhide">
    <div class="col-xl-3">
        <div class="card shadow-sm rounded bg-white sticky-top">
            <div class="card-body">
                <div>
                    <div class="row g-3" style="font-size:13px; font-weight: 500;">
                        <!-- Company Dropdown -->
                        <div class="col-12 pt-3 pb-2">
                            <label for="companySelect" class="form-label fw-semibold mb-0">Search
                                Company</label>
                            <select id="companySelect" class="form-select form-select-sm shadow-sm rounded"
                                [(ngModel)]="company_id" name="company_id" (change)="LoadGrid('Iner')">
                                <option value="0" selected>Choose Company</option>
                                <option *ngFor="let item of companyList" [value]="item.COMPANY_ID">{{
                                    item.COMPANY_NAME }}</option>
                            </select>
                        </div>

                        <!-- Categories -->
                        <div class="col-12 pb-2">
                            <label for="categorySelect" class="form-label fw-semibold mb-0">Categories</label>
                            <select id="categorySelect" class="form-select form-select-sm shadow-sm rounded"
                                [(ngModel)]="job_category_id" name="job_category_id" (change)="LoadGrid('Iner')">
                                <option value="0" selected>Choose Job Category</option>
                                <option *ngFor="let item of allDropDwns?.job_category" [value]="item.id">{{
                                    item.name }}</option>
                            </select>
                        </div>

                        <!-- Location -->
                        <div class="col-12 pb-2">
                            <label for="locationSelect" class="form-label fw-semibold mb-0">Location</label>
                            <select id="locationSelect" class="form-select form-select-sm shadow-sm rounded"
                                [(ngModel)]="county_id" name="county_id" (change)="LoadGrid('Iner')">
                                <option value="0" selected>Choose County</option>
                                <option *ngFor="let item of allDropDwns?.counties" [value]="item.counties_id">{{
                                    item.counties_name }}</option>
                            </select>
                        </div>

                        <!-- Job Types -->
                        <div class="col-12  pb-2">
                            <label class="form-label fw-semibold mb-0">Job Types</label>
                            <div class="d-flex flex-wrap gap-2 mt-2">
                                <div *ngFor="let d of jobTypeLst" class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="jobType{{d.id}}"
                                        [(ngModel)]="d.isSts" [ngModelOptions]="{ standalone: true }">
                                    <label class="form-check-label" for="jobType{{d.id}}">{{ d.name
                                        }}</label>
                                </div>
                            </div>
                        </div>

                        <!-- Salary -->
                        <div class="col-12 pb-2">
                            <label class="form-label fw-semibold mb-0">Salary</label>
                            <div class="mt-2">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="salary1" name="salaryRadio"
                                        (click)="isSalary='1';job_salary_from=10000;job_salary_to=15000"
                                        [checked]="isSalary=='1'">
                                    <label class="form-check-label" for="salary1">10k - 15k</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="salary2" name="salaryRadio"
                                        (click)="isSalary='2';job_salary_from=15000;job_salary_to=25000"
                                        [checked]="isSalary=='2'">
                                    <label class="form-check-label" for="salary2">15k - 25k</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" id="salary3" name="salaryRadio"
                                        (click)="isSalary='3';job_salary_from=25000;job_salary_to=10000000"
                                        [checked]="isSalary=='3'">
                                    <label class="form-check-label" for="salary3">More than 25k</label>
                                </div>
                            </div>
                        </div>
                        <!-- Submit Button -->
                        <div class="col-12">
                            <button type="button" class="btn btn-success w-100" (click)="LoadGrid('Iner')">Apply
                                Filter</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-9">
        <div class="row" *ngIf="listGrid.length > 0">
            <div class="col-xl-6 mb-2 pntr" *ngFor="let item of listGrid" (click)="jobDetails(item)">
                <div class="card mb-2 shadow-sm bg-white h-100" style="border-radius: 10px;">
                    <div class="card-body ">

                        <div class="d-flex justify-content-between">

                            <div>
                                <h5 class="mb-1 fw-bold">{{item.job_title}}</h5>
                            </div>
                            <div></div>
                        </div>
                        <small><strong></strong></small>
                        <div class="">
                            <div class="text-muted">
                                <span><i class="bi bi-calendar-check-fill"></i>
                                    {{item?.experience_level}}</span> &nbsp;
                                <br>
                                <br>
                                <span> <i class="bi bi-geo-alt-fill"></i>
                                    {{item?.counties_name}} - {{item?.sub_counties_name}}</span> &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="listGrid.length == 0">
            <h4>No Records Found</h4>
        </div>
    </div>
</div>